import React, { useState } from "react";
import FieldMappingRow from "./FieldMappingRow";
import { fieldSections, groupMappingsBySection, getFilteredMappings } from "../../utils/mappingHelpers";

const FieldMappingTable = ({
  fieldMappings,
  statusFilter,
  mappingFilter,
  onMappingChange,
  onDefaultValueChange,
  onDefaultValueChangeWithAutoSave,
  onMapValues,
  sourceFields = [],
  solutions = [],
}) => {
  // Section expanded states
  const [sectionStates, setSectionStates] = useState(
    Object.keys(fieldSections).reduce((acc, key) => {
      acc[key] = fieldSections[key].expanded;
      return acc;
    }, { ungrouped: true })
  );

  // Toggle section expanded/collapsed state
  const toggleSection = (sectionKey) => {
    setSectionStates(prev => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }));
  };

  // Get grouped and filtered mappings
  const getGroupedFilteredMappings = () => {
    const filtered = getFilteredMappings(fieldMappings, statusFilter, mappingFilter);
    return groupMappingsBySection(filtered);
  };

  const groupedMappings = getGroupedFilteredMappings();

  return (
    <div className="mapping-section">
      <table className="mapping-table">
        <thead>
          <tr className="mapping-table-subheader">
            <th className="mapping-column-header">Ace Field</th>
            <th className="mapping-column-header">Co-Sell Field</th>
            <th className="mapping-column-header">Opportunity Field</th>
            <th className="mapping-column-header mapped-header">Mapped</th>
            <th className="mapping-column-header">Map Picklist Values</th>
            <th className="mapping-column-header">Default Values</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(groupedMappings).map((sectionKey) => {
            const mappings = groupedMappings[sectionKey];

            // Skip empty sections
            if (mappings.length === 0) return null;

            const sectionConfig = fieldSections[sectionKey];
            const sectionTitle = sectionConfig?.title ||
              (sectionKey === 'ungrouped' ? 'Other Fields' : sectionKey);
            const sectionDescription = sectionConfig?.description;
            const isExpanded = sectionStates[sectionKey];

            return (
              <React.Fragment key={sectionKey}>
                {/* Section Header */}
                <tr className="mapping-table-header-row">
                  <td
                    colSpan="6"
                    className="mapping-table-header-cell"
                    onClick={() => toggleSection(sectionKey)}
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      className={`expand-icon ${isExpanded ? "expanded" : ""}`}
                      width="12"
                      height="7"
                      viewBox="0 0 8 5"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L4 4L7 1"
                        stroke="#6A8991"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{sectionTitle}</span>
                    {sectionDescription && (
                      <span
                        className="section-description"
                        style={{
                          marginLeft: '12px',
                          fontSize: '12px',
                          color: '#6A8991',
                          fontWeight: 'normal'
                        }}
                      >
                        {sectionDescription}
                      </span>
                    )}
                  </td>
                </tr>

                {/* Section Mapping Rows */}
                {isExpanded &&
                  mappings.map((mapping) => (
                    <FieldMappingRow
                      key={mapping.targetField.apiName}
                      mapping={mapping}
                      onMappingChange={onMappingChange}
                      onDefaultValueChange={onDefaultValueChange}
                      onDefaultValueChangeWithAutoSave={onDefaultValueChangeWithAutoSave}
                      onMapValues={onMapValues}
                      sourceFields={sourceFields}
                      solutions={solutions}
                    />
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FieldMappingTable;
